import { stringAvatar, stringToColor } from "../support/utils";
import { Avatar as AvatarMui, useTheme } from "@mui/material";

const Avatar = ({ token, sx, size = 60, fontSize = 11 }) => {
  const theme = useTheme();

  if (!token) return <AvatarMui sx={sx}>?</AvatarMui>;

  return (
    <AvatarMui
      color="primary"
      //variant="rounded"
      {...stringAvatar(
        token,
        theme,
        token.logoUrl ? "none" : stringToColor(token.address || "", theme),
        size,
        fontSize
      )}
      sx={{
        ...stringAvatar(
          token,
          theme,
          token.logoUrl ? "none" : stringToColor(token.address || "", theme),
          size,
          fontSize
        ).sx,
        ...sx,
      }}
      srcSet={
        token.logoUrl ||
        `https://www.dextools.io/resources/tokens/logos/ether/${token.address?.toLowerCase()}.png`
      }
    />
  );
};

export default Avatar;
